import {
  GridModalFormProps,
  UseFormReturnType,
  Validator,
  enumToOptions,
  useForm,
} from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { Params } from "react-router-dom";
import {
  PaymentTransaction,
  PaymentTransactionOptions,
  getPaymentTransactionService,
} from "./paymentTransactionApi";
import { PAYMENT_TRANSACTION_STATUS } from "./paymentTransactionConstants";

export interface UsePaymentTransactionFormProps extends GridModalFormProps {}

type RouteParams = {
  payment_transaction_id?: string;
};

export interface UsePaymentTransactionFormReturnType extends UseFormReturnType<
  PaymentTransaction,
  PaymentTransactionOptions
> {
  params?: Readonly<Params<"payment_transaction_id">>;
}

export default function usePaymentTransactionForm({
  id,
  afterSave,
  defaultValues,
}: UsePaymentTransactionFormProps): UsePaymentTransactionFormReturnType {
  const params = useParams<"payment_transaction_id">();
  const scope = undefined;
  const service = getPaymentTransactionService(scope);

  const form = useForm<PaymentTransaction, PaymentTransactionOptions>({
    id: params.payment_transaction_id || id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "PaymentTransaction",
    rules: {
      token: Validator.rule.string().required(),
      booking_id: Validator.rule.number().required(),
      status: Validator.rule.string().required(),
    },
    afterSave,
    ...service,
    loadOptions: async (cancel: any) => {
      const statusOptions = enumToOptions(
        PAYMENT_TRANSACTION_STATUS,
        "PaymentTransaction.options.status",
      );

      return {
        status: statusOptions,
      };
    },
    defaultValues: {
      status: "created",
      ...defaultValues,
    },
  });

  return {
    ...form,
    params,
  };
}
